import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import loader from '../../assets/images/three-dots.svg';

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: 200,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px 15px',
    flexWrap: 'wrap'
  },
  title: {
    marginBottom: '1rem'
  },
  recap: {
    fontSize: 19,
    textAlign: 'center'
  },
  resume: {
    fontSize: 21,
    color: '#002380'
  }
}));

const Step3 = ({
  order,
  currency,
  orderValue,
  valuation,
  valuationPercent,
  sharesNumber,
  sharePrice,
  dealSize,
  unitPrice,
  loading
}) => {
  const classes = useStyles();

  // const renderShares = () => {
  //   return (dealSize * (orderValue / 100)) / unitPrice;
  // };

  const renderPrice = (value, valuepercent, sharesnumber, shareprice) => {
    if (order.value === 1) return +(value * (valuepercent / 100)).toFixed(2);
    if (order.value === 2) return +(sharesnumber * shareprice).toFixed(2);
  };

  const renderCurrency = (value) => {
    switch (value) {
      case 1:
        return '€';
      case 2:
        return '$';
      default:
        return '$';
    }
  };

  const renderRecap = (orderId) => {
    switch (orderId) {
      case 1:
        return `${valuationPercent}% on a valuation of ${renderCurrency(
          currency.value
        )}${valuation}, for a total of ${renderCurrency(
          currency.value
        )}${renderPrice(valuation, valuationPercent, null, null)}`;
      case 2:
        return `${sharesNumber} shares at a unit price of ${renderCurrency(
          currency.value
        )}${unitPrice} for a total of ${renderCurrency(
          currency.value
        )}${renderPrice(null, null, sharesNumber, sharePrice)}`;
      default:
        return '';
    }
  };

  return (
    <div className={classes.container}>
      {loading ? (
        <img src={loader} alt="loading..." />
      ) : (
        <>
          <Typography gutterBottom className={classes.title} variant="h1">
            Recap of your order
          </Typography>
          <Typography gutterBottom className={classes.recap} variant="h4">
            You express your intention to buy: <br />
            <br />
            <span className={classes.resume}>{renderRecap(order.value)}</span>
          </Typography>
        </>
      )}
    </div>
  );
};

Step3.propTypes = {
  dealSize: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  order: PropTypes.object.isRequired,
  orderValue: PropTypes.number.isRequired,
  unitPrice: PropTypes.number.isRequired
};

export default Step3;
